import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe that strips HTML tags from a string, leaving only plain text.
 * Useful for displaying rich-text descriptions as plain text previews.
 *
 * Usage:
 *   {{ vacante.descripcion | stripHtml | slice:0:120 }}
 */
@Pipe({ name: 'stripHtml' })
export class StripHtmlPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    // Replace tags with a space (not empty) so adjacent text blocks
    // like "<p><strong>Empresa:</strong> CITI</p><p>Buscamos...</p>"
    // become "Empresa: CITI Buscamos..." instead of "CITIBuscamos"
    return value.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  }
}
